import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { IntegrityMonitorAssignRulesFormDataProviderFactory } from '../factory/IntegrityMonitorAssignRulesFormDataProviderFactory';
import { IntegrityMonitorAssignRulesFormBaseDataProvider } from '../dataProvider/IntegrityMonitorAssignRulesFormBaseDataProvider';
import { RuleSetOption } from '../types';

export class IntegrityMonitorAssignRulesFormRepository extends BaseWebComponentRepository {
  public dataProviderFactory: IntegrityMonitorAssignRulesFormDataProviderFactory;
  public dataProvider: IntegrityMonitorAssignRulesFormBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new IntegrityMonitorAssignRulesFormDataProviderFactory(),
    });
  }

  async getRuleSetOptions(): Promise<Array<RuleSetOption>> {
    return await this.dataProvider.getRuleSetOptions();
  }

  async assignRulesToRuleSets(
    companyId: string,
    ruleIds: Array<string>,
    ruleSetIds: Array<string>
  ): Promise<Object | null> {
    return await this.dataProvider.assignRulesToRuleSets(companyId, ruleIds, ruleSetIds);
  }
}
